/* eslint-disable react/jsx-one-expression-per-line */
/* eslint-disable max-len */
import React from 'react';
import cx from 'classnames';

import { Hyperlink } from '@motorway/mw-highway-code/alpha';

import styles from '../StaticContents.module.scss';

const ModulrPaymentTermsText = () => (
	<div className={cx(styles.staticContents, styles.container)}>
		<div className={cx(styles.center, styles.bold, styles['mb-64'])}>
			<h3>SCHEDULE 1</h3>
			<h3 className={styles.underline}>INTRODUCED CLIENT SCHEDULE</h3>
			<h3 className={styles.underline}>MODULR INTRODUCED CLIENT TERMS OF BUSINESS</h3>
		</div>
		<h3>BACKGROUND</h3>
		<p>
			Modulr is a provider of Modulr Products (as described to you by Partner Platform), which includes the provision of
			an electronic money account for businesses and associated payment services. The electronic money account is
			provided by Modulr FS. These Introduced Client Terms of Business govern the Modulr Products that Modulr agrees to
			provide to the Introduced Client.
		</p>
		<p>
			These Introduced Client Terms of Business (including all the attached Schedules), together with the Modulr Account
			Terms and Conditions set out the terms on which the Modulr Products are provided and constitute the Agreement
			between Modulr, Modulr FS and the Introduced Client.
		</p>
		<h3>THE PARTIES AGREE AS FOLLOWS:</h3>
		<br />
		<ol className={cx(styles.termsListRoot, styles['mb-64'])}>
			<li>
				<h3>Interpretation</h3>
				<ol>
					<li>
						In these Introduced Client Terms of Business: (a) a reference to a clause is a reference to a clause in
						these Introduced Client Terms of Business; (b) headings are for reference only and shall not affect the
						interpretation of these Introduced Client Terms of Business; (c) the singular shall include the plural and
						vice versa; (d) a reference to a person includes a natural person, corporate or unincorporated body (whether
						or not having separate legal personality) and that person's personal representatives, successors and
						permitted assigns; (e) a reference to a party shall include its personal representatives, successors and
						permitted assigns; (f) reference to a statute or statutory provision is a reference to it as amended,
						extended or re-enacted from time to time.
					</li>
				</ol>
			</li>
			<li>
				<h3>Modulr Products</h3>
				<ol>
					<li>
						Modulr will make available to the Introduced Client such products that are provided to the Partner Platform
						and, as described by Partner Platform in the application process.
					</li>
					<li>
						The Introduced Client agrees to the Partner Platform providing all such information to Modulr who will check
						and verify the identity of the Introduced Client, its directors, beneficial owners and Authorised Users as
						required by law.
					</li>
					<li>
						The Introduced Client acknowledges that a search of the electoral register may take place for anti-money
						laundering purposes on the individuals listed in clause 2.2 above.
					</li>
					<li>
						The Introduced Client acknowledges that a “soft footprint” search may be placed on the electronic files of
						the individuals noted in clause 2.2 above by the Credit Reference Agencies and their personal details may be
						accessed by third parties for the specific purpose of anti-money laundering and countering the financing of
						terrorism (AML/CFT), identity verification and fraud prevention.{' '}
					</li>
					<li>
						The Account and Cards (where applicable) are provided by Modulr FS to the Introduced Client in accordance
						with the Modulr Account Terms and Conditions. Modulr Products provided to the Introduced Client under this
						Agreement are for the sole use by the Introduced Client.{' '}
					</li>
					<li>
						The Introduced Client can use the Account and Cards (where applicable) to make Transactions on the terms and
						conditions set out in the Modulr Account Terms and Conditions. A record of all Transactions relating to the
						Account can be viewed on the Website or accessed via the Partner Platform (as applicable).{' '}
					</li>
					<li>
						The Introduced Client shall promptly notify Customer Services as soon as it becomes aware login and security
						information enabling access to its Modulr Products have been lost, stolen or compromised.
					</li>
					<li>
						From time to time Modulr may carry out additional checks on the Introduced Client, including the identity of
						its directors, beneficial owners and the nature of its business in accordance with its Due Diligence
						Procedure and as required by law. Modulr may contact the Introduced Client or the Partner Platform (as
						applicable) for such purposes. The Introduced Client agrees to provide such information as necessary.
					</li>
					<li>
						The Introduced Client shall comply with all legislation and regulation as it applies to the Introduced
						Client. Any failure to comply with relevant legislation or regulation shall be considered a material breach
						of the Agreement and may result in Modulr discontinuing the provision of the Modulr Products as set out in
						clause 6.4.
					</li>
					<li>
						The Introduced Client shall implement as appropriate Modulr’s reasonable security recommendations it
						notifies to the Introduced Client from time to time.
					</li>
				</ol>
			</li>
			<li>
				<h3>Authorised Users</h3>
				<ol>
					<li>
						Access to the Modulr Products is restricted to individuals that have been designated by the Introduced
						Client as Authorised Users.
					</li>
					<li>The Introduced Client must notify Modulr of all individuals it wishes to be an Authorised User.</li>
					<li>
						Each Authorised User is permitted to access and use the Modulr Products in accordance with these Introduced
						Client Terms of Business.
					</li>
					<li>
						The Introduced Client will be responsible for training its Authorised Users in the appropriate use of Modulr
						Products.
					</li>
					<li>
						The Introduced Client shall ensure its Authorised Users;
						<ol>
							<li>
								take all reasonable care to ensure Modulr Product access credentials, including login details to the
								Website, where applicable, are kept confidential to each Authorised User; and
							</li>
							<li>
								do not share any information that would enable another party to access the Introduced Client’s Account.
							</li>
						</ol>
					</li>
					<li>
						The Introduced Client acknowledges and agrees that each Authorised User is authorised by the Introduced
						Client to act on its behalf. Modulr shall deem any instruction given by an Authorised User is an instruction
						given by the Introduced Client.
					</li>
					<li>
						The Introduced Client will be responsible for timely notification to Modulr of any revocation of Authorised
						User access and will be liable for Transactions made, Fees incurred and use of Modulr Products by an
						Authorised User until Modulr has had one full Business Day to act on any received notice. This clause shall
						not apply to Introduced Clients accessing Modulr Products via the Partner Platform.{' '}
					</li>
					<li>
						Where the Introduced Client accesses Modulr Products through a Partner Platform, such Partner Platform will
						be considered the Authorised User. In this instance if additional Authorised Users are required they must be
						requested by the Partner Platform. The use of a Partner Platform to access the Modulr Products by the
						Introduced Client are set out in further detail below.
					</li>
				</ol>
			</li>
			<li>
				<h3>Accessing Modulr Products through a Partner Platform</h3>
				<ol>
					<li>
						In the event the Introduced Client utilizes a Partner Platform to access Modulr Products, the Introduced
						Client agrees and authorises the Partner Platform to instruct Modulr to access and use the Modulr Products
						on behalf of the Introduced Client, which shall include but not be limited to making Transactions, viewing
						and retrieving Transaction data, initiating refunds and closing the Account.
					</li>
					<li>
						The Introduced Client acknowledges and agrees that Modulr shall have no liability whatsoever with respect to
						the performance, availability or quality of any Partner Platform.
					</li>
					<li>
						The Introduced Client acknowledges and agrees to the following:
						<ol>
							<li>
								it must satisfy itself that its Platform Partner Agreement grants the Partner Platform all permission
								necessary to operate the Account on the Introduced Client’s behalf;
							</li>
							<li>
								the Platform Partner will be granted full access to operate the Introduced Client’s Account as an
								Authorised User of the Introduced Client;
							</li>
							<li>
								it is responsible for monitoring Partner Platform activities on its Account. Any queries relating to
								such activities will be raised with the Partner Platform directly and settled between Partner Platform
								and the Introduced Client;
							</li>
							<li>
								the Introduced Client has no recourse against Modulr for any act or omission of the Partner Platform
								with respect to its Account;
							</li>
							<li>
								the Introduced Client understands it can only access its Account to make Transactions, review
								Transactions made or otherwise use Modulr Products through the service provided by the Partner Platform;
								and
							</li>
							<li>it will only use the Account for the purpose set out in the Partner Platform Agreement. </li>
						</ol>
					</li>
					<li>
						On receipt of notification by Modulr from the Partner Platform that it wishes to terminate this Agreement,
						this Agreement shall terminate. Any funds in the Introduced Client’s Account will be returned in accordance
						with the terms of the Modulr Account Terms and Conditions.
					</li>
					<li>
						If the Introduced Client has any complaint or concern relating to the Account or other Modulr Products, such
						complaint or concern shall be raised directly to the Partner Platform, who shall deal with it in accordance
						with Modulr’s Complaints Policy, a copy of which is available on request from the Partner Platform and on
						the Website.
					</li>
				</ol>
			</li>
			<li>
				<h3>Customer Services</h3>
				<ol>
					<li>
						The Introduced Client can contact Customer Services if it has any queries about the Modulr Products.
						Information may be requested from the Introduced Client, including but not limited to, its Authorised Users,
						Cardholders or Transaction information so that it can verify the identity of an Authorised User, the
						Cardholder and/or the Modulr Products provided to such Introduced Client.
					</li>
					<li>
						Any information shared by the Introduced Client will be kept strictly confidential. Where such information
						is provided in connection to a service provided by a third party, for example, the Account, then the
						Introduced Client’s information will only be used in accordance with instructions of such third party and
						only for the purpose of providing Customer Services to the Introduced Client on behalf of such third party.
					</li>
					<li>
						As part of Modulr’s commitment to providing a quality customer service, its managers periodically monitor
						telephone communications between its employees and Introduced Clients to ensure that Modulr’s high quality
						service standards are maintained. The Introduced Client consents to such monitoring and recording of
						telephone communications and agrees to make its Authorised Users aware of such practice.{' '}
					</li>
				</ol>
			</li>
			<li>
				<h3>Term and Termination</h3>
				<ol>
					<li>
						This Agreement shall commence on the date the Introduced Client receives confirmation from Modulr or the
						Partner Platform (where applicable) of its successful application for Modulr Products and shall continue
						until terminated by the Introduced Client, Partner Platform (if acting on behalf of the Introduced Client)
						or Modulr.
					</li>
					<li>
						The Introduced Client or the Partner Platform (where applicable) may terminate this Agreement immediately by
						notifying Customer Services in writing by post or email.
					</li>
					<li>
						Modulr may terminate this Agreement and close the Introduced Client’s Account(s) by providing the Introduced
						Client with at least two months’ notice.{' '}
					</li>
					<li>
						Modulr may suspend or terminate this Agreement immediately if, for any reason, the Introduced Client (i) is
						unable to satisfy the Due Diligence Procedures, (ii) for breach of this Agreement, (iii) has provided false,
						incomplete or misleading information, (iv) has engaged in fraudulent, money laundering, terrorism financing
						or other illegal activity or we have reasonable suspicions in respect of same or (v) we are required to do
						so under any applicable law or regulation or at the direction of any regulatory, law enforcement or other
						competent authority. Modulr shall notify you as soon as possible, unless prohibited by law, of such
						suspension or termination of the Agreement.{' '}
					</li>
					<li>
						This Agreement will automatically terminate when all Accounts of the Introduced Client are closed (for any
						reason).
					</li>
					<li>
						Modulr may terminate or suspend this Agreement in whole or in part immediately by giving written notice to
						the Introduced Client if Modulr ceases to provide Cards pursuant to the provisions of Schedule 1.
					</li>
					<li>
						On termination of this Agreement for any reason, any balance remaining in the Introduced Client’s Account(s)
						shall be returned to the Introduced Client in accordance with the Modulr Account Terms and Conditions. The
						Introduced Client shall pay immediately all outstanding Fees due (where applicable) under this Agreement and
						in the event of a negative balance in an Account, shall reimburse Modulr FS such amount equal to the
						negative balance.
					</li>
				</ol>
			</li>
			<li>
				<h3>Intellectual Property</h3>
				<ol>
					<li>
						The Introduced Client acknowledges all Intellectual Property Rights in the Modulr Products are owned by or
						provided under licence to Modulr. Modulr grants the Introduced Client a non-exclusive, royalty-free licence
						for the duration of this Agreement to access and use the Modulr Products only for the purpose contemplated
						by this Agreement.
					</li>
					<li>
						Nothing in this Agreement shall operate to create or transfer any Intellectual Property Right to the
						Introduced Client.
					</li>
				</ol>
			</li>
			<li>
				<h3>Force Majeure</h3>
				<ol>
					<li>
						Modulr and/or Modulr FS will not be liable for the non-performance or failure to provide any part of the
						Modulr Products occurring as a result of any events that are beyond the reasonable control of Modulr, for
						example, but not limited to, fire, telecommunications or internet failure, utility failure, power failure,
						equipment failure, employment strife, riot, war, terrorist attack, non-performance of third party suppliers,
						acts of God such as storm or lightening damage, or other causes over which Modulr and/or Modulr FS has no
						reasonable control.
					</li>
				</ol>
			</li>
			<li>
				<h3>Assignment Transfer and Subcontracting</h3>
				<ol>
					<li>
						The Modulr Products provided to the Introduced Client are personal to the Introduced Client. The Introduced
						Client may not novate, assign or otherwise transfer this Agreement, any interest or right under this
						Agreement (in whole or in part) without the prior written consent of Modulr.{' '}
					</li>
					<li>
						The Introduced Client agrees Modulr may, in its sole discretion, assign, or transfer some or all of its
						rights and obligations or delegate any duty of performance set out in the documents forming this Agreement.
						Modulr may subcontract any of its obligations under this Agreement.
					</li>
					<li>
						In the event of any transfer of this Agreement by Modulr to another service provider; if the Introduced
						Client does not want to transfer to the new provider, the Introduced Client must notify Modulr of its
						objection in writing to Customer Services. On receipt of such notification, Modulr it will terminate this
						Agreement. Any balance remaining in the Introduced Client’s Account(s) will be returned to the Introduced
						Client in accordance with the redemption procedure set out in the Modulr Account Terms and Conditions.
					</li>
					<li>
						It is acknowledged by the Introduced Client that Modulr enters into this Agreement on its own behalf and as
						agent for and on behalf of Modulr FS with respect only to clauses 10 and 14 of these Introduced Client Terms
						of Business.
					</li>
				</ol>
			</li>
			<li>
				<h3>Liability</h3>
				<ol>
					<li>
						Nothing in this Agreement will operate to limit either party or its agent’s liability with respect to fraud
						or for death or personal injury resulting from negligence, in either case whether committed by that party or
						its employees, agents or subcontractors.
					</li>
					<li>
						Modulr and Modulr FS makes no warranty that access to and use of the Modulr Products will be uninterrupted
						or error free.
					</li>
					<li>
						The Introduced Client acknowledges and agrees that Modulr and/or Modulr FS are not liable to the Introduced
						Client for any loss, liability or damages the Introduced Client suffers which result from, are related to,
						or in any way are connected with any fraud control, restriction measures or other measures implemented from
						time to time including as require, unless such loss, liability or damage is a direct result of Modulr and/or
						Modulr FS’s fraud, gross negligence or willful misconduct in procuring the implementation of fraud control
						or purchase restriction measures that Modulr has expressly agreed in writing to procure for the Introduced
						Client.
					</li>
					<li>
						Modulr and Modulr FS shall not be liable to the Introduced Client for any loss or damage the Introduced
						Client may suffer as a result of any act or omission of an Authorised User or Cardholder or an Authorised
						User’s or Cardholder’s use of or inability to use of the Modulr Products.
					</li>
					<li>
						The Introduced Client agrees to indemnify Modulr and Modulr FS against any and all actions, claims, costs,
						damages, demands, expenses, liabilities, losses and proceedings Modulr and/or Modulr FS directly or
						indirectly incurs or which are brought against Modulr if the Introduced Client, or an Authorised User, or a
						Cardholder has acted fraudulently, been negligent or has misused a Modulr Product or any of the services
						provided under this Agreement.
					</li>
					<li>
						Modulr and/or Modulr FS shall not be responsible in any way for any interest or claims of any third parties
						in respect of the Modulr Products, except as required by law or regulation.
					</li>
				</ol>
			</li>
			<li>
				<h3>Reports</h3>
				<ol>
					<li>
						Modulr may make available certain management or other reporting or business administration functionality via
						the Website.{' '}
					</li>
					<li>
						Modulr may from time to time amend, modify, replace or withdraw in whole or in part such reporting it
						provides without further notice.
					</li>
				</ol>
			</li>
			<li>
				<h3>Data Privacy</h3>
				<ol>
					<li>
						Modulr will collect and retain personal information about the Introduced Client and each Authorised User and
						Cardholder to enable Modulr to deliver the Modulr Products, the services linked to it and deal with any
						enquiries that the Introduced Client may have about it. Modulr is the data controller of the personal
						information gathered by Modulr for such purpose. If Modulr uses a third party to provide a part of the
						Modulr Product then that provider will be the owner and controller of the personal information they require
						to collect in order to operate the relevant service. The use of personal information by third-party service
						providers will be set out in their service terms and conditions of use. Modulr will, at such third-party
						provider’s direction, process personal data on its behalf, for example, to enable Modulr to provide Customer
						Services to the Introduced Client.
					</li>
					<li>
						Modulr processes personal information in accordance with relevant laws on the protection of personal data.{' '}
					</li>
					<li>
						If Modulr transfers the Introduced Client’s information to a third party in a country outside of the
						European Economic Area Modulr will ensure that the third party agrees to apply the same levels of protection
						that Modulr is legally obliged to have in place when Modulr processes personal data.
					</li>
					<li>
						Further information about how Modulr uses personal information can be found in Modulr’s Privacy Policy;
						please contact Customer Services for a copy of this.
					</li>
				</ol>
			</li>
			<li>
				<h3>Changes to the Agreement</h3>
				<ol>
					<li>
						Modulr may amend or modify this Agreement by giving no less than two (2) months’ notice to the Introduced
						Client unless Modulr is required to make such a change sooner by law. All proposed changes will be posted on
						the Website and communicated to the Introduced Client by such other means that Modulr agreed with the
						Introduced Client, for example by email. If the Introduced Client is accessing Modulr Products via a Partner
						Platform, all notifications will be communicated via such Partner Platform.{' '}
					</li>
					<li>The Introduced Client has no obligation to accept such amendments proposed by Modulr.</li>
					<li>
						The Introduced Client will be taken to have accepted any change to this Agreement that Modulr notifies to
						the Introduced Client unless the Introduced Client tells Modulr otherwise before the relevant change takes
						effect. In such circumstance, Modulr will treat notice of objection by the Introduced Client as notification
						that the Introduced Client wishes to terminate this Agreement and the use of all Modulr Products
						immediately. All Accounts of the Introduced Client will be closed and any balance remaining in the
						Introduced Client’s Account will be returned to the Introduced Client in accordance with the redemption
						procedure set out in the Modulr Account Terms and Conditions. In this circumstance the Introduced Client
						will not be charged a fee for the Account closure and return of any balance.
					</li>
				</ol>
			</li>
			<li>
				<h3>General</h3>
				<ol>
					<li>
						In these Introduced Client Terms of Business, headings are for convenience only and shall not affect the
						interpretation of these Introduced Client Terms of Business.{' '}
					</li>
					<li>
						Any delay or failure by Modulr to exercise any right or remedy under this Agreement shall not be interpreted
						as a waiver of that right or remedy or stop Modulr from exercising its rights at any subsequent time.
					</li>
					<li>
						In the event that any part of this Agreement is held not to be enforceable, this shall not affect the
						remainder of the Agreement which shall remain in full force and effect.
					</li>
					<li>
						The Introduced Client shall remain responsible for complying with this Agreement until its Account(s) are
						closed (for whatever reason) and all sums due under this Agreement have been paid in full.
					</li>
					<li>
						This Agreement is written and available only in English and all correspondence with the Introduced Client
						shall be in English.{' '}
					</li>
					<li>
						This Agreement is governed by the laws of England and the Introduced Client agrees to the non-exclusive
						jurisdiction of the English courts.
					</li>
				</ol>
			</li>
		</ol>
		<div className={cx(styles.center, styles.bold, styles['mb-64'])}>
			<h3>Schedule 1: Card Obligations</h3>
			<h3>NOT USED</h3>
		</div>
		<div className={cx(styles.center, styles.bold, styles['mb-64'])}>
			<h3>Schedule 2 – Direct Debit Collection Service</h3>
			<h3>NOT USED</h3>
		</div>
		<div className={cx(styles.center, styles.bold, styles['mb-64'])}>
			<h3>Schedule 3 – Direct Debit Mandate Service</h3>
		</div>
		<ol className={cx(styles.termsListRoot, styles['mb-64'])}>
			<li>
				<h3>Introduction</h3>
				<ol>
					<li>
						{' '}
						The terms of this Schedule 3 shall apply where BACS Direct Debit Mandates are included within the Modulr
						Products.
					</li>
				</ol>
			</li>
			<li>
				<h3>Direct Debit Mandate Service</h3>
				<ol>
					<li>
						The Direct Debit Mandate service enables the Introduced Client and / or Account Manager to set up Direct
						Debit Mandates on an Account via UK BACS Direct Debit scheme (“Direct Debit Mandate Service”). The amounts
						and payment dates of the Direct Debits may vary.
					</li>
					<li>
						The Introduced Clients (or the Partner Platform or the Account Manager acting on the Introduced Client’s
						behalf) will be able to set up a Direct Debit Mandate on the Account by completing a Direct Debit Mandate
						form.
					</li>
					<li>
						The Introduced Client will be able to view or cancel a Direct Debit Mandate on the Introduced Client’s
						Account via the user interface provided by Partner Platform.
					</li>
					<li>
						Without prejudice to any other rights of Modulr, Modulr may withdraw the Direct Debit Mandate Service by
						giving the Introduced Client at least 2 months’ notice by e-mail.
					</li>
				</ol>
			</li>
		</ol>
		<div className={cx(styles.center, styles.bold, styles['mb-64'])}>
			<h3>Schedule 4 – PIS Terms and Conditions</h3>
		</div>
		<ol className={cx(styles.termsListRoot, styles['mb-64'])}>
			<li>
				<h3>INTRODUCTION</h3>
				<ol>
					<li>
						The terms of Schedule 4 shall apply where the PIS is included within the Modulr Products provided to you.
					</li>
					<li>
						These PIS Terms and Conditions, alongside the Modulr Account Terms and Conditions form the agreement between
						Modulr FS and you and sets out the terms that apply to your use of PIS as defined below.
					</li>
					<li>
						We are authorised by the Financial Conduct Authority (FRN 900573) for the issuance of electronic money and
						providing payment services, including payment initiation services.
					</li>
					<li>
						Unless expressly stated in this Schedule 4, the definitions contained in this Agreement shall apply to this
						Schedule 4.
					</li>
				</ol>
			</li>
			<li>
				<h3>DEFINITIONS</h3>
				<div className={styles.termsKeys}>
					<div>
						<strong>Account Servicing Payment Service Provider</strong> or <strong>ASPSP</strong> – the third party
						payment service provider, such as a bank, with whom you or the End User holds an online payment account
						(Source Account) which we will access when you use PIS;
					</div>
					<div>
						<strong>End User</strong> – means your customer who wishes to purchase your goods and/or services using PIS,
						and who holds a Source Account;
					</div>
					<div>
						<strong>Information</strong> – in relation to PIS, means any information related to you, and any personal
						information related to the End User;
					</div>
					<div>
						<strong>Payment Initiation</strong> – means either (i) a payment order initiated at your request from your
						Source Account to your Modulr Account ; or (ii) a payment order initiated at the request of an End User from
						their Source Account to your Account;
					</div>
					<div>
						<strong>Payment Initiation Service</strong> or <strong>PIS</strong> – means a service to initiate a payment
						from a Source Account, as more particularly described in clause 3.
					</div>
					<div>
						<strong>Source Account</strong> – a payment account accessible online which you or an End User holds with an
						ASPSP;
					</div>
					<div>
						<strong>Standing Order</strong> – a regular, recurring Payment Initiation as instructed by an End User.
					</div>
				</div>
			</li>
			<li>
				<h3>OUR SERVICES</h3>
				<ol>
					<li>
						You can only use PIS if you have an Account. You can continue to use PIS as long as you continue to hold an
						Account.
					</li>
					<li>
						You will be able to use our API to:
						<ol>
							<li>add funds to your Modulr Account from a Source Account;</li>
							<li>allow an End User to initiate a payment from a Source Account to your Account; and</li>
							<li>allow an End User to set up a Standing Order from their Source Account to your Account.</li>
						</ol>
					</li>
					<li>
						When using PIS to add funds to your Modulr Account, we will provide you with a redirection URL which will
						redirect you to your ASPSP, where you can log in using you ASPSP credentials and consent to the Payment
						Initiation from your Source Account.
					</li>
					<li>
						For End Users, we will provide you with a redirection URL to provide to the End User to redirect them to
						their ASPSP, where they can log in using their ASPSP credentials and consent to the Payment Initiation from
						their Source Account.
					</li>
					<li>
						We are not responsible for the services or provided by the ASPSP. The services provided in relation to the
						Source Account are subject to a separate agreement between you and your ASPSP, or the End User and their
						ASPSP.
					</li>
				</ol>
			</li>
			<li>
				<h3>END USERS</h3>
				<ol>
					<li>
						You will only allow End Users to request Payment Initiations and Standing Orders in accordance with these
						PIS Terms and Conditions and the End User Terms and Conditions (contained at Annex 1 to this Schedule 4).
					</li>
					<li>
						You will ensure that End Users have read and accepted the End User Terms and Conditions prior to the End
						User using PIS.
					</li>
					<li>
						You will keep a record of each End User’s confirmation given in accordance with clause 4.2 above and shall
						promptly make such records available to Modulr on request.
					</li>
					<li>
						You acknowledge that an End User may revoke their consent to process Payment Initiations or Standing Orders
						at any time, and Modulr shall not be liable to you for failing to provide the Information requested by you.
					</li>
					<li>
						We will not be able to revoke a transfer from a Source Account once it has been confirmed by an End User.
					</li>
					<li>
						Once an End User requests us to initiate a payment from a Source Account, Modulr will make the following
						information available to you and you must provide it immediately to the End User:
						<ol>
							<li>a confirmation that the payment has been successfully initiated with the End User’s ASPSP;</li>
							<li>
								a reference to identify the payment transaction and any information transferred with the payment order;
								and
							</li>
							<li>the amount of payment.</li>
						</ol>
					</li>
					<li>
						Where applicable, you will comply with Modulr’s PIS Customer Requirement Guidelines as provided to you by
						Partner Platform and as may be amended from time to time.
					</li>
				</ol>
			</li>
			<li>
				<h3>ACCOUNT TOP UP</h3>
				<ol>
					<li>You may use PIS to make a payment initiation for the purpose of adding funds to your Modulr Account.</li>
					<li>
						When you request us to initiate a payment from your Source Account, Modulr will make the following
						information available to you:
						<ol>
							<li>a confirmation that the payment has been successfully initiated with your ASPSP;</li>
							<li>
								a reference to identify the payment transaction and any information transferred with the payment order;
								and
							</li>
							<li>the amount of payment.</li>
						</ol>
					</li>
				</ol>
			</li>
			<li>
				<h3>SECURITY</h3>
				<ol>
					<li>You must not allow another person to use security information necessary to use PIS;</li>
					<li>
						We can restrict or suspend your ability to use PIS, including refusing to initiate the payment from a Source
						Account, if we are concerned about the security of your access to the Online Portal or the API, using PIS is
						causing or could cause a breach of these Terms and Conditions or if we have reasonable grounds for
						suspecting that you or a third party has committed or is about to commit a crime or other abuse in
						connection with your use of our API or Online Portal.
					</li>
					<li>
						If we restrict or suspend your use of PIS or refuse to initiate the payment from a Source Account, we will,
						without undue delay and provided we are legally permitted to do so, notify you. If possible, we will provide
						the reasons for this and where it is possible will provide reasons for the restriction or suspension and
						where those reasons relate to factual matters, the procedure of rectifying any factual errors that led to
						the restriction or suspension. Where we need to contact you, we will use the contact details associated with
						your Account, such as email, or telephone. You should inform us without delay if your contact details
						change.
					</li>
				</ol>
			</li>
			<li>
				<h3>DISPUTES AND INCORRECT TRANSACTIONS</h3>
				<ol>
					<li>
						If you or the End User have a reason to believe that a payment from a Source Account initiated by us was
						unauthorised or was made incorrectly, , the owner of the Source Account (i.e. you or the End User, as the
						context allows) should contact their ASPSP to resolve their query and we will cooperate with the ASPSP’s
						investigation in to such payment. Where we believe that the incorrect payment was due to our error in
						respect of the part of the Payment Initiation we were responsible for, we will refund the incorrectly
						initiated payment back to the original Source Account.{' '}
					</li>
					<li>
						You will be liable for all payments initiated through our API or Online Portal if you have acted
						fraudulently or with gross negligence (for example failed to keep your security information such as but not
						limited to the Online Portal log in details and API security details or Source Account credentials safe).
					</li>
				</ol>
			</li>
			<li>
				<h3>YOUR LIABILITY</h3>
				<ol>
					<li>You are responsible for understanding and complying with these PIS Terms and Conditions.</li>
					<li>
						You agree to indemnify and hold harmless, us, Modulr and our distributors, partners, agents, sponsors, and
						service providers and their group companies from and against the costs of any legal action (including any
						loss arising from action taken by a Regulator) taken to enforce these PIS Terms and Conditions and/or any
						breach of these PIS Terms and Conditions by you, including in respect of any non-compliance with clauses 4.2
						and 4.3 of these PIS Terms and Conditions.
					</li>
				</ol>
			</li>
			<li>
				<h3>OUR LIABILITY</h3>
				<ol>
					<li>
						In addition to our liability set out in the Modulr Account Terms and Conditions (whether arising in
						contract, tort (including negligence), breach of statutory duty or otherwise), where a Payment Initiation is
						incorrectly made from a Source Account due to our default, our liability shall be limited as appropriate (i)
						to refund to you an equivalent amount to which was incorrectly deducted from your Source Account; or (ii) to
						refund to the End User of an equivalent amount to that which was incorrectly deducted from their Source
						Account.
					</li>
				</ol>
			</li>
			<li>
				<h3>TERMINATION</h3>
				<ol>
					<li>These PIS Terms and Conditions will apply each time you use PIS in relation to your Account.</li>
					<li>We can terminate your access to PIS at any time if we give you two months’ notice.</li>
					<li>
						We can terminate your access to PIS at any time with immediate effect (and until your default has been
						remedied or these Terms and Conditions terminated) without any prior notice to you if:
						<ol>
							<li>we discover any of the Information that we hold for you is incorrect; or</li>
							<li>
								if we have reason to believe that you or a third party has committed or is about to commit a crime or
								other abuse (including fraud) in connection with your use of PIS; or
							</li>
							<li>you have breached these Terms and Conditions.</li>
						</ol>
					</li>
				</ol>
			</li>
		</ol>
		<div className={cx(styles.center, styles.bold, styles['mb-64'])}>
			<h3>ANNEX 1 TO SCHEDULE 4 –</h3>
			<h3>End User PIS Terms and Conditions</h3>
		</div>
		<h3>Important information you need to know</h3>
		<p>
			These End User PIS Terms and Conditions (“<strong>Terms and Conditions</strong>”) form the agreement between
			Modulr FS and you and sets out the terms that apply to your use of PIS as defined below.
		</p>
		<p>Please read these Terms and Conditions carefully before you agree to use PIS provided by us.</p>
		<p>
			By using PIS, you accept the terms of these Terms and Conditions. If there is anything you do not understand,
			please contact Customer Services using the contact details set out below. You can also request a copy of these
			Terms and Conditions at any time by contacting Customer Services.
		</p>
		<ol className={cx(styles.termsListRoot, styles['mb-64'])}>
			<li>
				<h3>DEFINITIONS</h3>
				<div className={styles.termsKeys}>
					<div>
						<strong>Account Servicing Payment Service Provider</strong> or <strong>ASPSP</strong> – the third party
						payment service provider, such as a bank, with whom you hold an online payment account (Source Account)
						which we will access when you use our Service.
					</div>
					<div>
						<strong>Customer Services</strong> – the contact centre for dealing with queries about our Services, who can
						be contacted at support@modulrfinance.com or 0303 313 0060.
					</div>
					<div>
						<strong>Data Protection Laws</strong> – the following, to the extent they are applicable to a party: the
						General Data Protection Regulation (EU) 2016/679, the Electronic Communications Data Protection Directive
						2002/58/EC, the Privacy and Electronic Communications (EC Directive) Regulations 2003 and all applicable
						laws and regulations relating to processing of personal data and privacy (as amended or replaced from time
						to time), including where applicable the guidance and codes of practice issued by the Information
						Commissioner (in the United Kingdom) or other applicable supervisory authority.
					</div>
					<div>
						<strong>Information</strong> – means any personal information related to you
					</div>
					<div>
						<strong>Merchant</strong> – the entity legally responsible for the Modulr Account, from whom you are
						purchasing goods or services.
					</div>
					<div>
						<strong>Modulr</strong> – Modulr Finance Ltd,a company registered in England and Wales with number 09897957
						and whose registered office is at Scale Space, 58 Wood Lane, London, W12 7RZ. Modulr Finance Ltd (FRN:
						900699) is a registered agent of Modulr FS Ltd.
					</div>
					<div>
						<strong>Modulr Account</strong> – the electronic account provided by us to the Merchant.
					</div>
					<div>
						<strong>Payment Initiation Service</strong> or <strong>PIS</strong> – means a service to initiate a payment
						at your request from a Source Account held by you, as more particularly described in clause 3.1.
					</div>
					<div>
						<strong>Source Account</strong> – a payment account accessible online which you hold with an ASPSP;
					</div>
					<div>
						<strong>Standing Order</strong> – a regular, recurring Payment Initiation as instructed by you.
					</div>
					<div>
						<strong>we, us, our or Modulr FS</strong> – Modulr FS Ltd, a company registered in England and Wales with
						number 09897919 and whose registered office is at Scale Space, 58 Wood Lane, London, W12 7RZ and who is
						regulated by the Financial Conduct Authority for issuance of electronic money under FRN 900573, or Modulr
						acting on Modulr FS Ltd's behalf.
					</div>
					<div>
						<strong>you, your</strong> – the payee who wishes to use PIS to send funds to a Merchant's Modulr Account.
					</div>
				</div>
			</li>
			<li>
				<h3>SCOPE OF THESE TERMS AND CONDITIONS</h3>
				<ol>
					<li>
						These Terms and Conditions apply to your use of PIS. We are authorised by the Financial Conduct Authority
						(FRN 900573) for the issuance of electronic money and providing payment services, including payment
						initiation services. Your rights and obligations relating to the use of PIS are subject to these Terms and
						Conditions between you and us.
					</li>
					<li>
						These Terms and Conditions are written and available only in English and we undertake to communicate with
						you in English regarding any aspect of your use of PIS.
					</li>
				</ol>
			</li>
			<li>
				<h3>OUR SERVICES</h3>
				<ol>
					<li>
						You will be able to initiate a payment from your Source Account to the Merchant’s Modulr Account, or set up
						a Standing Order. You will need to select the linked Source Account and the amount when you ask us to
						initiate the payment.
					</li>
					<li>
						We may use internet providers, web browsers and other third parties to access your Source Account held with
						the ASPSP, so that we can transmit the information relating to your Source Account or initiate the payment.
					</li>
					<li>
						The services provided to you in relation to your Source Account are subject to a separate agreement between
						you and the ASPSP. We are not responsible for the services or provided to you by the ASPSP.
					</li>
				</ol>
			</li>
			<li>
				<h3>USING THE SERVICES</h3>
				<ol>
					<li>
						Each time you use our PIS, you are giving us your explicit consent to initiate the payment from your Source
						Account to the Modulr Account for the amount you select at the time of your request.
					</li>
					<li>
						You will need to provide the same identifying information that you use when logging into to access your
						Source Account online with your ASPSP, such as your user name, password and/or other security information
						(such as answers to challenge questions or one-time-passcodes) (“<strong>Security Credentials</strong>”).
						You will need to provide your Security Credentials to:
						<ol>
							<li>link the Source Account; and</li>
							<li>authorise a payment from your Source Account you have asked us to initiate</li>
						</ol>
					</li>
					<li>We will not be able to revoke a transfer from your Source Account once you have confirmed it.</li>
					<li>
						Once you request us to initiate a payment from your Source Account, the Merchant will provide:
						<ol>
							<li>a confirmation that the payment has been successfully initiated with your ASPSP;</li>
							<li>
								a reference to identify the payment transaction and any information transferred with the payment order;
								and
							</li>
							<li>the amount of payment.</li>
						</ol>
					</li>
				</ol>
			</li>
			<li>
				<h3>STANDING ORDERS</h3>
				<ol>
					<li>
						You will be able to set up a Standing Order to make regular, recurring Payment Initiations to the Merchant’s
						Modulr Account. When setting up a Standing Order, you are giving us explicit consent to initiate a regular,
						recurring Payment Initiations from your Source Account to the Modulr Account for the amount you select at
						the time of your request.
					</li>
					<li>
						You must provide the following information to allow us to set up the Standing Order: the date of the first
						Payment Initiation, the amount of the Standing Order, and if the Standing Order is not open-ended, the date
						of the final Payment Initiation.
					</li>
					<li>
						If you wish to amend or cancel a Standing Order, you must contact your ASPSP. Modulr is not able to amend or
						cancel Standing Orders and accepts no liability for Standing Orders which have been incorrectly amended or
						cancelled.
					</li>
				</ol>
			</li>
			<li>
				<h3>FEES</h3>
				<p>We will not charge you any fees for using PIS.</p>
			</li>
			<li>
				<h3>STANDING ORDERS</h3>
				<ol>
					<li>
						You must not:
						<ol>
							<li>allow another person to use security information necessary to use PIS;</li>
							<li>
								write down password(s) or any security information unless this is done in a way that would make it
								impossible for anyone else to recognise any of that information; or
							</li>
							<li>
								disclose passwords or any security information, or otherwise make them available to any other person,
								whether verbally or by entering them in a way that allows them to be observed by others.
							</li>
						</ol>
					</li>
					<li>
						We can restrict or suspend your ability to use PIS, including refusing to initiate the payment from your
						Source Account, if we are concerned that using PIS is causing or could cause a breach of these Terms and
						Conditions or if we have reasonable grounds for suspecting that you or a third party has committed or is
						about to commit a crime or other abuse in connection with your use of our PIS.
					</li>
					<li>
						If we refuse to initiate the payment from your Source Account, we will, without undue delay and provided we
						are legally permitted to do so, notify you, via the Merchant. If possible, we will provide the reasons for
						this and where it is possible will provide reasons for the restriction or suspension and where those reasons
						relate to factual matters, the procedure of rectifying any factual errors that led to the restriction or
						suspension.
					</li>
				</ol>
			</li>
			<li>
				<h3>DISPUTES AND INCORRECT TRANSACTIONS</h3>
				<ol>
					<li>
						If you have a reason to believe that a payment from your Source Account initiated using our PIS was
						unauthorised or was made incorrectly, you can contact your ASPSP to resolve your query and we will cooperate
						with the ASPSP’s investigation in to such payment. Where we believe that the incorrect payment was due to
						our error in respect of the part of the initiated payment we were responsible for, we will refund the
						incorrectly initiated payment back to the original Source Account.{' '}
					</li>
					<li>
						You will be liable for all payments initiated through our PIS if you have acted fraudulently or with gross
						negligence (for example failed to keep your security information or Source Account Security Credentials
						safe).
					</li>
					<li>
						In circumstances where payment is initiated from your Source Account by us is disputed by you or your ASPSP,
						if we require your support to enable us to establish the cause of the incorrectly initiated payment, you
						agree to provide us with all assistance that we reasonably require.
					</li>
				</ol>
			</li>
			<li>
				<h3>YOUR LIABILITY</h3>
				<ol>
					<li>You are responsible for understanding and complying with these Terms and Conditions.</li>
					<li>
						It is your responsibility to keep the Merchant updated of changes to your Information, including e-mail
						address and mobile numbers. Failure to do so may result in us being unable to contact you regarding our PIS
						or to let you know about changes to these Terms and Conditions.
					</li>
					<li>
						You agree to indemnify and hold harmless, us, Modulr and our distributors, partners, agents, sponsors, and
						service providers and their group companies from and against the costs of any legal action taken to enforce
						these Terms and Conditions and/or any breach of these Terms and Conditions by you.
					</li>
				</ol>
			</li>
			<li>
				<h3>OUR LIABILITY</h3>
				<ol>
					<li>
						Our liability in connection with this these Terms and Conditions (whether arising in contract, tort
						(including negligence), breach of statutory duty or otherwise) shall be subject to the following exclusions
						and limitations:
						<ol>
							<li>
								we shall not be liable for any default resulting directly or indirectly from any cause beyond our
								control;
							</li>
							<li>
								we shall not be liable for any loss of profits, loss of business, or any indirect, consequential,
								special or punitive losses;
							</li>
							<li>
								where payment is incorrectly initiated from your Source Account due to our default, our liability shall
								be limited to refund to you of an equivalent amount to that which was incorrectly deducted from your
								Source Account.
							</li>
						</ol>
					</li>
					<li>
						Nothing in these Terms and Conditions shall exclude or limit our liability for death or personal injury
						resulting from our negligence or fraud.
					</li>
					<li>
						To the extent permitted by law, all conditions or warranties implied by law, statute or otherwise are
						expressly excluded.
					</li>
					<li>
						The above exclusions and limitations set out in this paragraph shall apply to any liability of our
						affiliates and other suppliers, contractors, agents or distributors and any of their respective affiliates
						(if any), to you, which may arise in connection with these Terms and Conditions.
					</li>
				</ol>
			</li>
			<li>
				<h3>VARIATION</h3>
				<ol>
					<li>Each time you use our PIS you will be bound by the Terms of Service in force at that time.</li>
					<li>
						From time to time, we may update these Terms and Conditions. If we do this then we will provide an updated
						copy to Merchants and you will be bound by those new terms the next time you use our PIS. If you do not
						agree to those changes you should not use our PIS.
					</li>
					<li>
						If any part of these Terms and Conditions are inconsistent with any legal requirements then we will not rely
						on that part but treat it as if it did actually reflect the relevant legal requirement. If we need to make
						operational changes before we can fully comply with the new regulatory requirement, we will make those
						changes as soon as reasonably practical.
					</li>
				</ol>
			</li>
			<li>
				<h3>TERMINATION OR SUSPENSION</h3>
				<ol>
					<li>
						We may at any time terminate or withhold your access to all or any part of our PIS at any time, effective
						immediately:
						<ol>
							<li>
								if you have breached any provision of these Terms and Conditions (or have acted in a manner which
								clearly shows that you do not intend to, or are unable to comply with the provisions of these Terms and
								Conditions); or
							</li>
							<li>
								if we, in our sole discretion, believe we are required to do so by law (for example, where the provision
								of the PIS to you is, or becomes, unlawful).
							</li>
						</ol>
					</li>
				</ol>
			</li>
			<li>
				<h3>YOUR INFORMATION</h3>
				<ol>
					<li>
						You may provide us with your Information from time to time in connection with your use of PIS. Some
						Information, especially the Account Information, will be necessary for us to provide you with the PIS under
						these Terms and Conditions.
					</li>
					<li>
						We and our affiliates are committed to maintaining your Information in accordance with the requirements of
						the Data Protection Laws. You acknowledge and agree that any Information provided by you or a third party on
						your behalf to us shall be used, kept and may be disclosed to third parties in accordance with our Privacy
						Policy which is available on our website. We will take all reasonable steps to ensure that your Information
						is kept secure against unauthorised access, loss, disclosure or destruction. Except as required by law, or
						in accordance with these Terms and Conditions, your Information will not be passed to anyone without your
						permission.
					</li>
					<li>
						You explicitly consent to us accessing, processing and retaining any Information you provide to us for the
						purposes of providing payment services to you. This does not affect any rights and obligations you or we
						have under Data Protection Laws. You agree that we can use your Information in connection with the PIS, to
						enable us to review, develop and improve our products and services. This may involve providing your
						Information to our partners, affiliates, agents, distributors and suppliers to process transactions and for
						their statistical research and analytical purposes. We may also disclose your Information as required by
						law, regulation or any competent authority or agency to investigate possible fraudulent, unlawful or
						unauthorised activity. You may withdraw your consent at any time. If you do this, we will stop providing our
						PIS to you and stop using your Information to provide payment services to you. We may continue to process
						your Information for other purposes, for example where we are required by law to do so.
					</li>
					<li>
						If we discover that the Information we hold about you is incorrect, we may have to suspend or cancel your
						access to the PIS until we can establish the correct Information, in order to protect us both.
					</li>
				</ol>
			</li>
			<li>
				<h3>COMPLAINTS PROCEDURE</h3>
				<ol>
					<li>Complaints regarding any element of the PIS provided by us can be sent to Customer Services.</li>
					<li>
						All complaints will be subject to our complaints procedure. We will provide you with a copy of our
						complaints procedure upon request and, if we receive a complaint from you, a copy of our complaints
						procedure will automatically be posted or emailed to you.
					</li>
					<li>
						In most cases we will provide a full response by email to your complaint within fifteen business days after
						the date we receive your complaint. In exceptional circumstances where we are unable to respond in full to
						your complaint, we will inform you of this giving our reasons for the delay and the timeframe within which
						you will receive a full reply, which in any event shall be within thirty-five days of the date we received
						your complaint.{' '}
					</li>
					<li>
						If we fail to resolve your complaint to your satisfaction you may refer your complaint to the Financial
						Ombudsman Service (Exchange Tower, London E14 9SR, phone 0800 023 4567). Details of the service offered by
						the Financial Ombudsman Service are available at www.financial-ombudsman.org.uk.
					</li>
				</ol>
			</li>
			<li>
				<h3>GENERAL</h3>
				<ol>
					<li>
						Any delay or failure to exercise any right or remedy under these Terms and Conditions by us shall not be
						construed as a waiver of that right or remedy or preclude its exercise at any subsequent time.
					</li>
					<li>
						If any provision of these Terms and Conditions is deemed unenforceable or illegal, the remaining provisions
						will continue in full force and effect.
					</li>
					<li>
						You may not assign or transfer any of your rights and/or benefits under these Terms and Conditions and you
						shall be the sole party to the contract between us. We may assign our rights and benefits at any time
						without prior written notice to you. We may subcontract any of our obligations under these Terms and
						Conditions.
					</li>
					<li>
						Save for Modulr, who act on our behalf, no third party who is not a party to these Terms and Conditions has
						a right to enforce any of the provisions in these Terms and Conditions.
					</li>
					<li>
						These Terms and Conditions are governed by English law and you agree to the exclusive jurisdiction of the
						courts of England and Wales.
					</li>
				</ol>
			</li>
		</ol>
		<div className={cx(styles['mb-64'])}>
			<h3>Schedule 5: Confirmation of Payee</h3>
		</div>
		<p>For the purposes of this Schedule, the following definitions shall apply:</p>
		<br />
		<ol className={cx(styles.termsListRoot, styles['mb-64'])}>
			<div className={styles.termsKeys}>
				<div>
					"<strong>CoP Operating Guide</strong>" means the operating guide published by Pay.UK in force at the time of
					this Agreement and as updated from time to time;
				</div>
				<div>
					"<strong>CoP Rules</strong>" means the rules contained in the Confirmation of Payee Rulebook published by
					Pay.UK in force at the time of this Agreement and as updated from time to time;
				</div>
				<div>
					"<strong>Data Privacy Notice</strong>" means the Modulr privacy policy available online at{' '}
					<Hyperlink
						href="https://www.modulrfinance.com/privacy-policy"
						label="https://www.modulrfinance.com/privacy-policy"
						target="_blank"
						variant="secondary"
					/>
					, as updated from time to time; and
				</div>
				<div>
					"<strong>Modulr CoP</strong> <strong>Developer Guide</strong>" means the documentation relating to CoP made
					available to Partner Platform in the Modulr Developer Centre, as updated from time to time.
				</div>
			</div>
			<li>
				<h3>Introduction</h3>
				<ol>
					<li>
						These CoP Terms and Conditions shall apply where Confirmation of Payee (“CoP”) is included within the Modulr
						Products provided to you.
					</li>
					<li>
						These CoP Terms and Conditions, alongside the Modulr Account Terms and Conditions form the agreement between
						Modulr FS and you and sets out the terms that apply to your use of CoP as defined below.{' '}
					</li>
				</ol>
			</li>
			<li>
				<h3>Compliance with Confirmation of Payee Rules</h3>
				<ol>
					<li>Where applicable, you will comply with all CoP Rules as they apply to CoP.</li>
					<li>
						The Introduced Client shall be responsible for ensuring that any authorised user who uses CoP complies with
						these terms and conditions and Modulr Account Terms and Conditions.
					</li>
				</ol>
			</li>
			<li>
				<h3>Confirmation of Payee</h3>
				<ol>
					<li>
						CoP allows the account details of a payee to be checked with their payment service provider before a payment
						is instructed and made by the sender.
					</li>
					<p>
						<strong>Outbound requests – Checking a payee’s details before making a payment</strong>
					</p>
					<li>
						Modulr FS enables access to the Application Programming Interface (API) used by Modulr FS to send requests
						to the payee’s payment service provider in order to check that the details entered match the details of the
						person or business to be paid.
					</li>
					<li>
						When setting up a new payee for a payment (eg. Faster Payment), you must provide:
						<ol>
							<li>the payee’s full name, account number and sort code; and</li>
							<li>the type of account that will be paid (eg. either Business or Personal).</li>
						</ol>
					</li>
					<li>
						Modulr FS will then send a request to the receiving payment service provider to check these details and
						provide the Partner Platform with a result within the API in line with the CoP Rules and Modulr CoP
						Developer Guide. These results include but are not limited to:
						<ol>
							<li>the account name is a match;</li>
							<li>the account name is a close match; and</li>
							<li>the account name is not a match.</li>
						</ol>
					</li>
					<li>
						Partner Platform will then display results to you in accordance with the CoP Rules and the Modulr CoP
						Developer Guide, as agreed with Modulr FS.
					</li>
					<li>
						It is acknowledged that, notwithstanding any results returned pursuant to clauses 3.4 and 3.5 above:
						<ol>
							<li>
								the decision as to whether to proceed to payment or not remains with you. For the avoidance of doubt, if
								a payment is made by you and the money is ultimately sent to an incorrect account, Modulr FS may not be
								able to get the money back; and
							</li>
							<li>Modulr FS will not be liable for any subsequent properly authorised and executed payment.</li>
						</ol>
					</li>
					<p>
						<strong>Inbound requests – Receiving a payment</strong>
					</p>
					<li>
						Modulr FS intends to enable checks made by other participants of CoP against accounts held with it and
						respond to such requests from a payer’s payment service provider in order to check that the details provided
						match that of the intended payee.
					</li>
					<li>The use of this service, when available, will be subject to FAQs and the Data Privacy Notice.</li>
				</ol>
			</li>
			<li>
				<h3>Fair usage</h3>
				<ol>
					<li>
						The use of CoP is subject to conditions contained in the CoP Rules, which include but are not limited to:
						<ol>
							<li>CoP may only be used by you in anticipation of making a payment; and</li>
							<li>
								the number of the requests by you shall not exceed limits included in the CoP Rules and determined by
								Modulr FS from time to time.
							</li>
						</ol>
					</li>
					<li>
						For the avoidance of doubt, a breach of these fair usage provisions shall be a breach of these CoP Terms and
						Conditions which could result in the suspension or termination of this service.
					</li>
				</ol>
			</li>
		</ol>
		<h3>Part C: - The Modulr Account Terms and Conditions; Important information you need to know</h3>
		<p>The Modulr Account Terms and Conditions:</p>
		<p>
			Please read these Terms and Conditions carefully before you agree to use an Account or any related services
			provided by or through us.
		</p>
		<p>
			These Terms and Conditions, together with the Introduced Client Terms of Business constitute the entire agreement
			between Modulr and you.
		</p>
		<p>
			By signing the Modulr Account Terms and Conditions you accept the terms of the Agreement, or by agreeing to open
			an Account and/or using our services, you accept these Terms and Conditions. If there is anything you do not
			understand, please contact Customer Services using the contact details provided to you by Partner Platform.
		</p>
		<ol className={cx(styles.termsListRoot, styles['mb-64'])}>
			<li>
				<h3>DEFINITIONS</h3>
				<div className={styles.termsKeys}>
					<div>
						<strong>Account</strong> – The electronic money account, also known as Modulr Account provided by us in
						accordance with these Terms and Conditions.
					</div>
					<div>
						<strong>Account Information Service Provider</strong> – means a third party payment service provider who is
						authorised by or registered with the Financial Conduct Authority or another European regulator to provide
						online account information services, who, with your permission will be able to access certain online account
						information on one or more payment accounts held by you to give you a consolidated view of your payment
						accounts.
					</div>
					<div>
						<strong>Account Limit</strong> – any limit that applies in relation to your Account and/or Card, such as
						account maximum balance, and limits on receiving and sending payments from your Account as referred in
						paragraph 2.
					</div>
					<div>
						<strong>Account Manager</strong> – The individuals elected by the Account Owner to be responsible for the
						management of the Account, also known as an "Authorised User".
					</div>
					<div>
						<strong>Account Owner</strong> – The entity legally responsible for an Account.
					</div>
					<div>
						<strong>Agreement</strong> – The agreement for your Account made up of these Terms and Conditions, together
						with the Introduced Client Terms of Business which constitute the entire agreement between you and Modulr.
					</div>
					<div>
						<strong>Application Programming Interface (API)</strong> – means the interfaces provided by Modulr to the
						Introduced Client (and the Partner Platform on the Introduced Client's behalf) to directly instruct Accounts
						via the Introduced Client's or the Partner Platform's own application.
					</div>
					<div>
						<strong>AML Policy</strong> – Modulr's written policy on anti–money laundering and counter terrorist
						financing as may be amended from time to time by Modulr.
					</div>
					<div>
						<strong>Applicant</strong> – A customer of the Partner Platform who applies for Modulr Products but is yet
						to be accepted by the Modulr as an Introduced Client.
					</div>
					<div>
						<strong>Available Balance</strong> – The value of funds available on your Account.
					</div>
					<div>
						<strong>Bacs Credit</strong> – Means Bacs Direct Credit. A serviceenabling organisations to make payments to
						an account which takes 3 Business Days for the funds to be cleared.
					</div>
					<div>
						<strong>Business Days</strong> – Monday to Friday between the hours of 9am–5pm but does not include bank
						holidays, or public holidays in the United Kingdom.
					</div>
					<div>
						<strong>Card</strong> – means a Virtual Card or a Physical Card.
					</div>
					<div>
						<strong>Cardholder</strong> – means the individual authorised to use the Physical Card issued to you.
					</div>
					<div>
						<strong>Card Scheme</strong> –Mastercard and/or Visa or such other payment network through which Card
						Transactions are processed as may be made available to you from time to time.
					</div>
					<div>
						<strong>Card Transaction</strong> – means a Virtual Card Transaction or a Physical Card Transaction.
					</div>
					<div>
						<strong>CHAPS</strong> – the Clearing House Automated Payment System, a service enabling organisations to
						make same–day payments to an account within the UK, within the CHAPS operating days and times.
					</div>
					<div>
						<strong>Chargeback</strong> has the meaning given to it in Schedule 1 of the Introduced Client Terms of
						Business.
					</div>
					<div>
						<strong>Confidential Information</strong> – any information (whether or not recorded in documentary form, or
						stored on any magnetic or optical disk or memory) relating to: the business, products, affairs, strategy,
						contracts, customer relationships, commercial pipelines, business contacts, prospective customers, existing
						customers, business models, customer pricing, management systems, business methods, corporate plans,
						maturing new business opportunities, research and development projects, marketing and sales information,
						sales targets and statistics, discount structures, suppliers and potential suppliers, source codes, computer
						programs inventions, know–how, technical specifications and other technical information relating to products
						and services.
					</div>
					<div>
						<strong>Customer Services</strong> – The contact centre for dealing with queries about your Account. Contact
						details for Customer Services can be obtained from the Partner Platform.
					</div>
					<div>
						<strong>Data Protection Laws</strong> – the following, to the extent they are applicable to a party: the
						Data Protection Act 2018, the General Data Protection Regulation (EU) 2016/679, the Electronic
						Communications Data Protection Directive 2002/58/EC, the Privacy and Electronic Communications (EC
						Directive) Regulations 2003 and all applicable laws and regulations relating to processing of personal data
						and privacy (as amended or replaced from time to time), including where applicable the guidance and codes of
						practice issued by the Information Commissioner (in the United Kingdom) or other applicable supervisory
						authority;
					</div>
					<div>
						<strong>Direct Debit</strong> – a payment collected via UK Direct Debit scheme operated by Bacs from or to
						your Account.
					</div>
					<div>
						<strong>Direct Debit Collection</strong> – a payment collected to your Account via UK Direct Debit scheme on
						the basis of an instruction given by you to the payer's payment service provider.
					</div>
					<div>
						<strong>Direct Debit Guarantee</strong> – means the refund terms applicable to Direct Debit Mandates as set
						out on the direct debit form or direct debit confirmation provided to you by the payment recipient.
					</div>
					<div>
						<strong>Direct Debit Mandate</strong> – a payment collected from your Account via UK Direct Debit scheme on
						the basis of a mandate permitting someone else (recipient) to instruct us to transfer money from your
						Account to that recipient.
					</div>
					<div>
						<strong>Due Diligence Procedure</strong> – Modulr's procedures for carrying out due diligence on Introduced
						Clients in order to comply with its policies and regulatory obligations.
					</div>
					<div>
						<strong>Faster Payment</strong> – A service allowing you to make and receive electronic payments in the UK
						which is received by the recipient bank within 2 hours provided that the receiving organisation or bank is
						part of Faster Payments Scheme.
					</div>
					<div>
						<strong>Fees</strong> – where relevant, those fees payable by the Introduced Client.
					</div>
					<div>
						<strong>Information</strong> – Means any information related to the organisation, and any personal
						information related to Account Manager or the Cardholder.
					</div>
					<div>
						<strong>Intellectual Property Rights</strong> – means without limitation, all patents (including models and
						inventions), trademarks, service marks, trade names, domain names, business names, copyrights, design
						rights, database rights, rights to or in computer software, know–how, trade secrets, rights to or in
						confidential information and all other intellectual property rights and rights or forms of protection of a
						similar nature or effect which may subsist anywhere in the world whether or not registered or capable of
						registration, together with all applications for registration of, and any licence to use, any of the
						foregoing and "Intellectual Property" shall be construed accordingly;
					</div>
					<div>
						<strong>Introduced Client</strong> – Any client of Modulr which has been introduced by the Partner Platform
						and whose account is operated by the Partner Platform based on instructions the Partner Platform receives
						from the Introduced Client (where relevant).
					</div>
					<div>
						<strong>Introduced Client Terms of Business</strong> – The terms on which Modulr provides Modulr Products to
						the Introduced Client.
					</div>
					<div>
						<strong>Merchan</strong> – means a merchant authorised to accept Card Scheme–branded Cards.
					</div>
					<div>
						<strong>Modulr</strong> – Modulr Finance Ltd,a company registered in England and Wales with number 09897957
						and whose registered office is at Scale Space, 58 Wood Lane, London, W12 7RZ. Modulr Finance Ltd (FRN:
						900699) is a registered agent of Modulr FS Ltd.
					</div>
					<div>
						<strong>Modulr Account Terms and Conditions</strong> – This agreement, between Modulr FS and the Introduced
						Client which governs the terms on which the Introduced Client may use its Account.
					</div>
					<div>
						<strong>Modulr Products</strong> – those products, including but not limited to the Account as described by
						Partner Platform in the application process.
					</div>
					<div>
						<strong>Online Portal</strong> – means the interface provided by Modulr for the Introduced Client to access
						via the public internet, subject to applicability based on the Introduced Client's relationship with the
						Partner Platform.
					</div>
					<div>
						<strong>Payment Initiation Service Provider</strong> – means a third party payment service provider
						authorised by or registered with by the Financial Conduct Authority or another European regulator to provide
						an online service to initiate a Transaction at your request on your Account.
					</div>
					<div>
						<strong>Partner Platform</strong> – A third party that is permitted by Modulr and Modulr FS to introduce and
						act on behalf of Introduced Clients, and permitted by you to act as an Authorised User.
					</div>
					<div>
						<strong>Partner Platform Agreement</strong> – an agreement between the Account Owner and the Partner
						Platform for the provision of various services, under the terms of which the Introduced Client wishes to
						open an Account with Modulr to be used for the purpose and in accordance with the terms set out in the
						Partner Platform Agreement.
					</div>
					<div>
						<strong>Physical Card</strong> – means a physical card–based payment instrument issued by us to you which
						uses the Card Scheme payments network and may be used to make Physical Card Transactions.
					</div>
					<div>
						<strong>Physical Card Transaction</strong> – means the use of a Physical Card to make a payment to a
						Merchant.
					</div>
					<div>
						<strong>Regulator</strong> – the Financial Conduct Authority, located at 12 Endeavour Square, London, E20
						1JN or any authority, body or person having, or who has had, responsibility for the supervision or
						regulation of any regulated activities or other financial services in the United Kingdom.
					</div>
					<div>
						<strong>SEPA</strong> – the Single Euro Payments Area is the area where citizens, companies and other
						economic actors can make and receive payments in euro, within Europe, whether within or across national
						boundaries under the same basic conditions, rights and obligations, regardless of their location. SEPA is
						driven by the European Commission and the European Central Bank, amongst others, as a key component of the
						EU Internal Market. SEPA shall be deemed to encompass the countries and territories which are part of the
						geographical scope of the SEPA Schemes, as listed in the EPC List of SEPA Scheme Countries, as amended from
						time to time.
					</div>
					<div>
						<strong>SEPA Credit Transfer</strong> – a service allowing you to make and receive non urgent EUR electronic
						payments within SEPA provided that the receiving organisation or bank is part of the scheme.
					</div>
					<div>
						<strong>SEPA Instant Credit Transfer</strong> – a service allowing you to make and receive near real time
						EUR electronic payments within SEPA provided that the receiving organisation or bank is part of the scheme.
					</div>
					<div>
						<strong>SEPA Transfers</strong> – means, together, SEPA Credit Transfer and SEPA Instant Credit Transfer.
					</div>
					<div>
						<strong>Transaction</strong> – any debit, credit or other adjustment to an Account that affects the balance
						of monies held in it, including a Virtual Card Transaction.
					</div>
					<div>
						<strong>TPP (Third Party Provider)</strong> – means an Account Information Service Provider or a Payment
						Initiation Service Provider.
					</div>
					<div>
						<strong>we, us, our or Modulr FS</strong> – Modulr FS Ltd, a company registered in England and Wales with
						number 09897919 and whose registered office is at Scale Space, 58 Wood Lane, London, W12 7RZ and who is
						regulated by the Financial Conduct Authority for issuance of electronic money under FRN 900573, or Modulr
						acting on Modulr FS Ltd's behalf.
					</div>
					<div>
						<strong>Virtual Card</strong> – means a virtual card–based payment instrument consisting of (amongst other
						things) a unique 16 digit account number issued to you by us which uses the Card Scheme payments network and
						may be used to make Virtual Card Transactions.
					</div>
					<div>
						<strong>Virtual Card Transaction</strong> – means the use of a Virtual Card to make a payment to a Merchant.
					</div>
					<div>
						<strong>Website</strong> – means the customer portal that Introduced Clients can login to in order to use
						the Modulr Products.
					</div>
					<div>
						<strong>you, your</strong> – The Account Owner, also referred to as an Introduced Client.
					</div>
				</div>
			</li>
			<li>
				<h3>ACCOUNT & CARD LIMITS</h3>
				<ol>
					<li>
						Limits may apply to the balance on your Account at any time, the maximum value of an individual payment
						Transaction, maximum Virtual Transaction value per Card, the maximum aggregate value of all payment
						Transactions made from your Account or Cards in a particular time period e.g. during any one Business Day
						and the maximum number of payment Transactions made from your Account over a particular timeframe. Your
						Cards may also have certain Card Transaction types disabled, such as cash withdrawals at an ATM.
					</li>
					<li>
						The limits and restrictions that apply to your Account and Card will be communicated to you during the
						Account set-up process and/or before the Card is issued to you (as applicable). These limits may also change
						over time based on your Account and/or Card usage; any such change will be communicated to you. You can
						check the limits at any time by contacting Customer Services. You should not make a payment Transaction
						request which exceeds such.
					</li>
					<li>
						From time to time a Card Transaction may be authorised which exceeds the limit or restriction applicable to
						your Account or Card, for example when it is used in an offline environment for example but not limited to
						payments for or on transport (purchases on a train, aeroplane, underground or toll payments). In such
						circumstance, a negative balance on your Account may occur. In this case the process in paragraphs 5.13 to
						5.15 inclusive will apply.
					</li>
					<li>
						Certain Merchants may require verification that the funds held on your Account will cover the Card
						Transaction amount and will place a “pre-authorisation” on your Card. This amount will be unavailable to you
						until the Card Transaction is completed or released by the Merchant. The pre-authorisation allows the
						Merchant up to 30 days to claim and settle any funds owed to them from the Card. Examples include but are
						not limited to hotels and rental cars. If there are insufficient funds available on your Account, Modulr
						must still make this settlement, which may result in a negative balance on your Account. In this case the
						process in paragraphs 5.13 to 5.15 inclusive will apply.
					</li>
					<li>
						To manage our risk, particularly with respect to money laundering, fraud or security concerns, we also apply
						internal controls, including limits, to certain types of payment. We change these as necessary but for
						security purposes, we do not disclose them.{' '}
					</li>
				</ol>
			</li>
			<li>
				<h3>SCOPE OF THESE TERMS AND CONDITIONS</h3>
				<ol>
					<li>
						Your Account is an electronic money account and the electronic money and any Card associated with it is
						issued to you by us. We are regulated by the Financial Conduct Authority for the issuance of electronic
						money (FRN 900573). Your rights and obligations relating to the use of this Account are subject to these
						Terms and Conditions between you and us.
					</li>
					<li>
						The types of Transactions enabled for your Account will be explained to you by the Partner Platform, or as
						subsequently enabled by us. The terms of these Modulr Account Terms and Conditions applicable to specific
						Transactions or payment types (for example, Cards) apply only to the extent that such Transactions or
						payment types are enabled for your Account.
					</li>
					<li>
						This Agreement is written and available only in English and we undertake to communicate with you in English
						regarding any aspect of your Account.
					</li>
					<li>
						You agree that we or the Partner Platform may communicate with you by e-mail or telephone for issuing any
						notices or information about your Account and therefore it is important that you ensure you keep your e-mail
						address and mobile phone number updated.
					</li>
					<li>You can request a copy of these Terms and Conditions at any time by contacting Customer Services.</li>
				</ol>
			</li>
			<li>
				<h3>OPENING YOUR ACCOUNT</h3>
				<ol>
					<li>
						{' '}
						Your Account will be opened on your behalf by the Partner Platform. You may only hold an Account so long as
						you remain an approved client of the Partner Platform that provided you with your account details.
					</li>
				</ol>
			</li>
			<li>
				<h3>USING THE ACCOUNT</h3>
				<ol>
					<li>
						Your Account can receive bank transfers and other payment types as added and notified to you by Modulr from
						time to time. Subject to paragraph 5.3, we will credit your Account when we receive the funds which could be
						up to three Business Days after the payment being instructed, depending on how the payment was sent.
					</li>
					<li>
						Your Account can also receive internal transfers from other Accounts owned or controlled by the Partner
						Platform, which apply instantly.
					</li>
					<li>
						An incoming payment will not be credited to your Account if:
						<ol>
							<li>the Account has reached the Account Limits; or</li>
							<li>the Account is inactive or blocked or terminated; or</li>
							<li>the sender has provided incorrect/invalid Account Details for your Account; or</li>
							<li>we suspect the payment to be fraudulent.</li>
						</ol>
					</li>
					<li>
						If we are unable to credit your Account for any of the reasons in paragraph 5.3 then the funds may be sent
						back to the sender without a prior notification to you.
					</li>
					<li>
						Your Account can make payments out to external bank accounts via Faster Payments, SEPA Transfer and other
						methods as added and notified to you by the Partner Platform from time to time.
					</li>
					<li>
						Your Account will be configured and operated by the Partner Platform. You agree that Modulr and we may take
						instructions from the Partner Platform regarding the operation of your Account, including the creation of
						beneficiaries and instruction of payments, on your behalf. We and Modulr have no liability for actions taken
						by the Partner Platform. If you disagree with any actions taken by the Partner Platform these should be
						discussed with the Partner Platform. We are also authorised to take instructions from any other Account
						Manager (where different from Partner Platform) and, with respect to Physical Card Transactions, from the
						Cardholder. You are responsible for all actions of the Account Manager and any Cardholder in relation to the
						Account and/or Card(s).
					</li>
					<li>
						Where Cards are made available to you, , your Account can be used to fund Card Transactions. You or your
						Account Manager or Partner Platform can request a Virtual Card or a Physical Card to be issued to you via
						the Online Portal or Modulr API. The value of the Virtual Card Transaction, together with any applicable
						fees and charges, will be deducted from your Account once we receive the authorisation request from the
						Merchant.
					</li>
					<li>
						If the Card Transaction is made in a currency other than the currency the Card is denominated in, the Card
						Transaction will be converted to the currency of the Card by the relevant Card Scheme at a rate set by it on
						the day we receive details of the Card Transaction. The exchange rate varies throughout the day and is not
						set by us. You can check the relevant Card Scheme rate as follows.
						<br />
						<span>
							Mastercard Card Scheme rate at:{' '}
							<Hyperlink
								href="https://www.mastercard.co.uk/en-gb/consumers/get-support/convert-currency.html"
								label="https://www.mastercard.co.uk/en-gb/consumers/get-support/convert-currency.html"
								target="_blank"
								variant="secondary"
							/>
							;
						</span>
						<br />
						<span>
							VISA Card Scheme rate at:{' '}
							<Hyperlink
								href="https://www.visa.co.uk/support/consumer/travel-support/exchange-rate-calculator.html"
								label="https://www.visa.co.uk/support/consumer/travel-support/exchange-rate-calculator.html"
								target="_blank"
								variant="secondary"
							/>
							.
						</span>
					</li>
					<li>
						A Transaction is deemed to be authorised by you:
						<ol>
							<li>
								when you or your Account Manager or Partner Platform enters the security information on the Modulr
								Online Portal to confirm a Transaction is authorised, or when it is instructed via the Modulr API with
								the relevant security credentials;
							</li>
							<li>
								when you or your Account Manager or Partner Platform submits a request for a creation of a Virtual Card
								via the Online Portal or Modulr API, you shall be deemed to have authorised any subsequent Virtual Card
								Transaction made using such Virtual Card up to the authorisation value specified when creating the
								request for creation of the Virtual Card;
							</li>
							<li>
								when you or the Cardholder (i) enter a PIN or provide any other security credentials; (ii) sign a sales
								voucher; (iii) provide the Physical Card details and/or provide any other details as requested; (iv)
								wave/swipe the Physical Card over a card reader; or (v) insert the Physical Card into a card device or
								an ATM;
							</li>
							<li>
								when you give instructions through a third party (such as the recipient of a Direct Debit Mandate or a
								Payment Initiation Service Provider).
								<br />
								<span>
									Once the Transaction is confirmed, we cannot revoke the Transaction save for in those circumstances
									set out in paragraph 5.10 below.
								</span>
							</li>
						</ol>
					</li>
					<li>
						You can cancel any Transaction which is agreed to take place on a date later than the date you authorised
						it, provided that you give us notice to cancel no later than close of business on the Business Day before
						the Transaction was due to take place;
					</li>
					<li>
						Cancelling a Direct Debit Mandate with us will not cancel the agreement with the organisation you are
						paying. It is your responsibility to tell the organisation collecting the payment about the changes to your
						instructions.
					</li>
					<li>
						If for any reason whatsoever, a negative balance arises because a Transaction is completed when there are
						not enough funds on your Account for that Transaction, you shall reimburse the negative balance amount
						immediately, unless circumstances described in sections 5.13 and 5.14 apply. You agree that once we make
						this negative balance known to you, we will charge you the amount of negative balance and you must repay it
						immediately. We may charge the amount of the negative balance against any funds on your Account, including
						any subsequently loaded funds. Until we are reimbursed this negative balance amount, we may arrange for your
						Account, including Card(s) to be suspended. We may also report the negative balance to credit reference
						agencies.
					</li>
					<li>
						Where a negative balance arises because of an error on the part of a Merchant where the Card Transaction
						occurred, we will seek to recover the negative balance amount from the Merchant.
					</li>
					<li>
						Where a negative balance arises because of an error on the part of the recipient of the payment or us, we
						will seek to recover the negative balance amount from the person who made the error.
					</li>
					<li>The Available Balance on your Account will not earn any interest.</li>
					<li>
						You can check the balance and Transaction history of your Account at any time via the interface provided to
						you by the Partner Platform or by contacting Customer Services, or the Online Portal if you have relevant
						access details.
					</li>
					<li>
						You will be provided with a monthly statement free of charge setting out information relating to individual
						payment Transactions by the Partner Platform or us (using the details we have associated with your Account).
					</li>
				</ol>
			</li>
			<li>
				<h3>THIRD PARTY ACCESS</h3>
				<ol>
					<li>
						You can instruct a TPP to access information on your Account or initiate certain Transactions from your
						Account provided such TPP has identified itself to us and it has acted in accordance with the relevant
						regulatory requirements. We will treat any instruction from an TPP as if it was from you or an Account
						Manager.
					</li>
					<li>
						We may deny a TPP access to your Account if we are concerned about unauthorised or fraudulent access by that
						TPP. setting out the reason for such denial. Before doing so, we will tell you that we intend to deny access
						and give our reasons for doing so, unless it is not reasonably practicable, in which case we will
						immediately inform you afterwards. In either case, we will tell you in the manner in which we consider most
						appropriate in the circumstances. We will not tell you if doing so would compromise our security measures or
						would otherwise be unlawful.
					</li>
					<li>
						If you have provided consent to a TPP to access the data in your Account to enable them to provide account
						information services to you or initiate Transactions on your behalf, you consent to us sharing your
						information with the TPP as is reasonably required for them to provide their services to you. You must let
						us know if you withdraw this permission and we recommend you let the TPP know. On notification from you, we
						will not provide such TPP access to your Account or the data in it.{' '}
					</li>
				</ol>
			</li>
			<li>
				<h3>CLOSING YOUR ACCOUNT</h3>
				<ol>
					<li>
						You may close your Account by contacting Customer Services. Please refer to your contract with the Partner
						Platform for any terms relating to your need to maintain your Account.{' '}
					</li>
					<li>
						The Account will be closed if the Partner Platform instructs us to close your Account (in which case the
						Partner Platform will inform you of this instruction).
					</li>
					<li>
						On termination of the Agreement for any reason, these Terms and Conditions will automatically terminate, and
						your Account will be closed and any Cards issued to you will be cancelled.
					</li>
					<li>
						Any Available Balance remaining on the Account after Account closure will be transferred to your nominated
						bank account via Faster Payments or SEPA Transfer (as relevant) based on instructions to us from the Partner
						Platform. If for any reason this is not possible, such Available Balance will remain yours for a period of
						six years from the date of Account closure. Within this period, you may at any time request a refund by
						contacting Customer Services. You will not have any access to your Account and we will not return any funds
						remaining on the Account after six years from the date of Account closure and this Agreement will terminate.
					</li>
				</ol>
			</li>
			<li>
				<h3>YOUR LIABILITY AND AUTHORISATIONS</h3>
				<ol>
					<li>
						You are responsible for understanding and complying with the Agreement including these Terms and Conditions.
					</li>
					<li>
						We may at any time suspend, restrict or refuse to authorise any use of your Account and/or Cards (including
						cancelling Card(s)) or refuse to process your instructions or authorise any particular Transaction where:
						<ol>
							<li>we are concerned about the security of or access to your Account and/or your Card;</li>
							<li>
								we know or suspect that that your Account and/or Card is being used in an unauthorised or fraudulent
								manner;
							</li>
							<li>
								we need to do so in order to comply with the law or otherwise for regulatory or crime prevention
								purposes;
							</li>
							<li>the Transaction would breach the limits applicable to your Account and/or Card; </li>
							<li>
								you, the Account Manager or the Cardholder breach an important part of these Terms and Conditions, or
								repeatedly breach any term in this Agreement and fail to resolve the matter in a timely manner.
							</li>
						</ol>
					</li>
					<li>
						If we cancel, suspend or restrict your Account and/or Card(s), or otherwise refuse to execute a payment
						order to or to initiate a Transaction, we will, without undue delay and provided we are legally permitted to
						do so, notify you or the Partner Platform of the refusal, suspension or cancellation (as applicable). If
						possible, we will provide the reasons for the refusal to execute the Transaction and/or suspending the use
						of your Account and/or Card and where those reasons relate to factual matters, the procedure of rectifying
						any factual errors that led to the refusal.
					</li>
					<li>
						You or the Account Manager or the Cardholder must not:
						<ol>
							<li>allow another person to use security information related to the Account and/or Cards,</li>
							<li>
								write down password(s) or any security information unless this is done in a way that would make it
								impossible for anyone else to recognise any of that information, or
							</li>
							<li>
								disclose passwords or any security information, or otherwise make them available to any other person,
								whether verbally or by entering them in a way that allows them to be observed by others.
							</li>
						</ol>
					</li>
					<li>
						You must take all reasonable steps to keep your Account and password(s) and any other security-related
						details safe at all times. If you visit a website or receive a message that asks for your password, other
						than the Modulr website, this should be reported to us. If you are in doubt whether a website is genuine,
						you should contact Customer Services. If you have any indication that your Account, password or other
						security information has been compromised, you must immediately change your password and notify us as soon
						as possible.
					</li>
					<li>
						You will be liable for all Transactions that take place as a result of you, the Account Manager or the
						Cardholder acting fraudulently or failing to comply with these Terms and Conditions with intent or gross
						negligence. Any such Transactions and any fees and charges relating to such Transactions will be deducted
						from the Available Balance on your Account.
					</li>
					<li>
						You will be liable for all Transactions that the Partner Platform, any other Account Manager makes on your
						behalf or the Cardholder makes as per this Agreement, along with those made by a TPP authorised by you to
						initiate a Transaction.
					</li>
					<li>
						You will be liable for all unauthorised Transactions that arise from the use of lost or stolen Physical
						Cards, the Account or Card security information such as but not limited to the Online Portal log in details
						and API security details, Card number and CVV if you, the Account Manager, or the Cardholder fail to keep
						the security features of the Account and/or Cards safe.
					</li>
					<li>
						It is your responsibility to keep us updated of changes to your Information, including e-mail address and
						mobile numbers. Failure to do so may result in us being unable to contact you regarding your Account or to
						let you know about changes to these Terms and Conditions.
					</li>
					<li>
						If you request to recall a Transaction due to an error or mistake caused other than by Modulr, we reserve
						the right to charge you (i) a handling fee of £25 per recall and (ii) any fee payable by Modulr to a
						third-party bank or institution for handling the recall.
					</li>
					<li>
						You agree to indemnify and hold harmless, us, Modulr and our distributors, partners, agents, sponsors, and
						service providers and their group companies from and against the costs of any legal action taken to enforce
						this Agreement, including these Terms and Conditions and/or any breach of these Terms and Conditions by you.
					</li>
				</ol>
			</li>
			<li>
				<h3>DISPUTES AND INCORRECT TRANSACTIONS</h3>
				<ol>
					<li>
						If you (or an Account Manager or Cardholder) have a reason to believe that (i) a Transaction on your Account
						was unauthorised or was made incorrectly, (ii) a Physical Card is lost or stolen; or (iii) someone else
						(other than TPP) knows the security credentials or otherwise has unauthorised access to your Account and/or
						Card, you must inform us immediately by contacting Customer Services. After you notify us, we will replace a
						lost, stolen or misappropriated Physical Card and/or security credentials, as appropriate.
					</li>
					<li>
						We will investigate your claim for a refund of unauthorised or incorrectly executed Transactions, provided
						at all times that you have notified us without undue delay of becoming aware of such incorrectly executed or
						unauthorised Transaction and in any case within the timeframes required by the Card Scheme rules if the
						incorrect Transaction relates to a Card Transaction and for all other Transactions within 13 months of the
						date of the relevant Transaction. We will not be liable for any unauthorised or incorrectly executed
						Transactions notified to us after this period.
					</li>
					<li>
						If you dispute a Transaction:
						<ol>
							<li>
								subject to 9.3.2 and 9.3.3 we will immediately refund the amount to your Account to the position it
								would have been in if the unauthorised Transaction had not taken place. We will have no further
								liability to you. If we subsequently discover that you were not entitled to a refund, we shall treat the
								refund as a mistake and be entitled to reapply the Transaction.
							</li>
							<li>
								if there are reasonable grounds for thinking that you may not be entitled to a refund (based on the
								evidence available to us at the time you report the unauthorised Transaction), we may investigate before
								giving you a refund and we will provide you with our supporting evidence if we believe you are not
								entitled to the refund;
							</li>
							<li>
								if the Transaction was initiated through a TPP, it is for the TPP to prove that, the Transaction was
								authenticated, accurately recorded and not affected by a technical breakdown or other deficiency linked
								to the TPP’s payment initiation service; and
							</li>
							<li>
								if we make an error on a Transaction made to someone else through the Direct Debit scheme, we will
								refund you in accordance with the Direct Debit Guarantee.
							</li>
						</ol>
					</li>
					<li>
						If an incorrect Transaction is paid into your Account that should not have, we will, where possible,
						immediately send the funds back to the bank acting for the person from whose account the Transaction was
						made. In such circumstance you agree to return the funds to us and provide such assistance that we require
						in recovering the amount from you. If we cannot recover the funds, we are required to provide sufficient
						details about you and the incorrect payment to the bank or institution that sent the payment to enable them
						to recover the funds.
					</li>
					<li>
						You will be liable for all Transactions made from your Account if you (or the Account Manager or the
						Cardholder) have acted fraudulently or have failed with gross negligence:
						<ol>
							<li>
								to keep the security credentials used to access or use your Account and/or Card safe and secure or
								otherwise failed to comply with these Terms and Conditions in relation to the safety of your Account
								and/or Card; or
							</li>
							<li>failed to notify us in accordance with 9.1 above.</li>
						</ol>
					</li>
					<li>
						You may be entitled to a refund where a Transaction from your account which was initiated by payee provided
						that:
						<ol>
							<li>the authorisation did not specify the exact amount;</li>
							<li>
								the amount of Transaction exceeded the amount you could reasonably have expected (taking into your
								previous spending pattern and other relevant circumstances). We may ask you to provide such information
								as is reasonably necessary for us to determine if this is correct; and
							</li>
							<li>
								you asked for a refund within 8 weeks of the date the Transaction was debited to your Account.
								<br />
								<span>
									In such circumstances we will refund you within 10 Business Days of receiving your claim for a refund
									or, where applicable, within 10 Business Days of receiving any further information we requested - or
									we will provide you with reasons for refusing the refund.
								</span>
							</li>
						</ol>
					</li>
					<li>
						If you want a refund for a Transaction made using the Direct Debit scheme, the Direct Debit Guarantee will
						apply instead of the terms in 9.6 above.
					</li>
				</ol>
			</li>
			<li>
				<h3>VARIATION</h3>
				<ol>
					<li>
						We may change these Terms and Conditions by providing you with at least two months’ prior notice by e-mail
						(provided you have supplied us with an up-to-date e-mail address).
					</li>
					<li>
						If you do not agree with the changes to the Terms and Conditions, you may at any time within the two months’
						notice period notify us and these Terms and Conditions will be terminated and your Account closed. If you do
						not notify us to the contrary during this period then you will be deemed to have accepted the change and it
						will apply to you when it comes into force.
					</li>
					<li>
						If any part of these Terms and Conditions are inconsistent with any legal requirements then we will not rely
						on that part but treat it as if it did actually reflect the relevant legal requirement. If we need to make
						operational changes before we can fully comply with the new regulatory requirement, we will make those
						changes as soon as reasonably practical.
					</li>
				</ol>
			</li>
			<li>
				<h3>TERMINATION OR SUSPENSION</h3>
				<ol>
					<li>
						We can terminate your Account at any time if we give you two months’ notice and transfer any Available
						Balance at the time to your nominated bank account without a charge.
					</li>
					<li>
						We can suspend or terminate your Account at any time with immediate effect (and until your default has been
						remedied or the Agreement terminated) without any prior notice to you if:
						<ol>
							<li>
								we discover any of the Information that we hold for you is false, misleading or materially incorrect; or
							</li>
							<li>
								if you, the Account Manager, the Cardholder or a third party has engaged in fraudulent activity, money
								laundering, terrorism, terrorism financing or other illegal activity in connection with your Account or
								we have reasonable suspicions in respect of the same; or
							</li>
							<li>if you have reached your Account Limit;</li>
							<li>you or the Account Manager have breached these Terms and Conditions; or</li>
							<li>
								we are required to do so under any applicable law or regulation or at the direction of any regulatory,
								law enforcement or other competent authority.
							</li>
						</ol>
					</li>
					<li>
						In the event that we do suspend or terminate your Account then if we are able to do so, we will tell you in
						advance otherwise we will let you know immediately afterwards (to the extent we are permitted by law).
					</li>
				</ol>
			</li>
			<li>
				<h3>OUR LIABILITY</h3>
				<ol>
					<li>
						Our liability and the liability of our agents in connection with this these Terms and Conditions (whether
						arising in contract, tort (including negligence), breach of statutory duty or otherwise) shall be subject to
						the following exclusions and limitations:
						<ol>
							<li>
								Neither we, nor our agents shall be liable for any default resulting directly or indirectly from any
								cause beyond our control, including but not limited to, a lack of funds;
							</li>
							<li>
								Neither we, nor our agents shall be liable for any loss of profits, loss of business, or any indirect,
								consequential, special or punitive losses;
							</li>
							<li>
								where sums are incorrectly deducted from your Available Balance due to our default, our liability and
								that of our agents shall be limited to payment to you of an equivalent amount to that which was
								incorrectly deducted from your Available Balance;
							</li>
							<li>
								in all other circumstances of our default, our liability and that of our agents jointly will be limited
								to transferring any Available Balance to your nominated bank account.
							</li>
						</ol>
					</li>
					<li>
						In circumstances where sums are incorrectly deducted from your Available Balance due to our fault, if we
						require your support to enable us to recover the incorrect deduction, you agree to provide us and our agents
						with all assistance that we reasonably require.
					</li>
					<li>
						Nothing in these Terms and Conditions shall exclude or limit our liability or that of our agents for death
						or personal injury resulting from our negligence or fraud.
					</li>
					<li>
						To the extent permitted by law, all conditions or warranties implied by law, statute or otherwise are
						expressly excluded.
					</li>
					<li>
						The above exclusions and limitations set out in this paragraph shall apply to any liability of our
						affiliates and other suppliers, contractors, agents or distributors and any of their respective affiliates
						(if any), to you, which may arise in connection with these Terms and Conditions.
					</li>
				</ol>
			</li>
			<li>
				<h3>YOUR INFORMATION</h3>
				<ol>
					<li>
						Some personal data will be necessary for us to provide you with the Account and services under this
						Agreement. Modulr FS is a Data Controller and shall only use your personal data for this purpose. Please see
						the Privacy Policy (please contact Customer Services for details of where to access this) for full details
						on the personal data that we and Modulr Finance Ltd hold, how we will use it and how we will keep it safe.
						Modulr will at all times comply with Data Protection Laws.
					</li>
					<li>
						We will retain details of individual transactions for six years from the date on which the particular
						transaction was completed. We will maintain all other records for six years from which we have ceased to
						provide you with any product or service
					</li>
					<li>You must update any changes to your Information by contacting Customer Services.</li>
					<li>
						If we discover that the Information we hold about you is incorrect, we may have to suspend or cancel your
						Account until we can establish the correct Information, in order to protect us both.
					</li>
					<li>
						If you or the Account Manager allow or give consent to an Authorised Third Party Provider to access your
						Account to provide their services, you should know that we have no control over how an Authorised Third
						Party Provider will use your information nor will we be liable for any loss of information after an
						Authorised Third Party Provider have access to your information.{' '}
					</li>
				</ol>
			</li>
			<li>
				<h3>COMPLAINTS PROCEDURE</h3>
				<ol>
					<li>Complaints regarding any element of the service provided by us can be sent to Customer Services.</li>
					<li>
						All complaints will be subject to our complaints procedure. We will provide you with a copy of our
						complaints procedure upon request and, if we receive a complaint from you, a copy of our complaints
						procedure will automatically be posted or emailed to you.
					</li>
					<li>
						In most cases we will provide a full response by email to your complaint within fifteen Business Days after
						the date we receive your complaint. In exceptional circumstances where we are unable to respond in full to
						your complaint, we will inform you of this giving our reasons for the delay and the timeframe within which
						you will receive a full reply, which in any event shall be within thirty-five Business Days of the date we
						received your complaint.{' '}
					</li>
					<li>
						If we fail to resolve your complaint to your satisfaction you may refer your complaint to the Financial
						Ombudsman Service (Exchange Tower, London E14 9SR, phone 0800 023 4567). Details of the service offered by
						the Financial Ombudsman Service are available at www.financial-ombudsman.org.uk.
					</li>
				</ol>
			</li>
			<li>
				<h3>GENERAL</h3>
				<ol>
					<li>
						Any delay or failure to exercise any right or remedy under these Terms and Conditions by us shall not be
						construed as a waiver of that right or remedy or preclude its exercise at any subsequent time.
					</li>
					<li>
						If any provision of these Terms and Conditions is deemed unenforceable or illegal, the remaining provisions
						will continue in full force and effect.
					</li>
					<li>
						You may not assign or transfer any of your rights and/or benefits under these Terms and Conditions and you
						shall be the sole party to the contract between us. You will remain liable until the Account issued to you
						is terminated. We may assign our rights and benefits at any time without prior written notice to you. We may
						subcontract any of our obligations under these Terms and Conditions.
					</li>
					<li>
						Save for Modulr, who acts on our behalf, no third party who is not a party to these Terms and Conditions has
						a right to enforce any of the provisions in these Terms and Conditions and the Contracts (Rights of Third
						Parties) Act 1999 shall not apply.
					</li>
					<li>
						These Terms and Conditions contain the information set out in Schedule 4 of the Payment Service Regulations
						2017 and you can obtain a copy of this Agreement at any time by contacting Customer Services.
					</li>
					<li>
						These Terms and Conditions are governed by English law and you agree to the exclusive jurisdiction of the
						courts of England and Wales.
					</li>
					<li>
						The Financial Services Compensation Scheme is not applicable for this Account. No other compensation schemes
						exist to cover losses claimed in connection with your Account. As a responsible e-money issuer, we will
						ensure that once we have received your funds they are deposited in a safeguarded account in accordance with
						our legal obligations. In the event that we become insolvent funds that are safeguarded by us are protected
						against the claims made by our creditors.
					</li>
				</ol>
			</li>
			<li>
				<h3>CONTACTING CUSTOMER SERVICES</h3>
				<ol>
					<li>
						Customer Services are provided by the Partner Platform. The details shall be provided by the Partner
						Platform.
					</li>
				</ol>
			</li>
		</ol>
	</div>
);

export default ModulrPaymentTermsText;
